import React, { useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";

function IncomingCallForm({ phoneNumber, addAsJobsheet }) {
  const [formData, setFormData] = useState({
    number: phoneNumber,
  });

  function handleFormData(e) {
    let { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  }

  return (
    <div className="no-contacts-found">
      <h3>No Matching Contacts Found</h3>
      <form>
        <div>
          <div className="formLine">
            <label htmlFor="authorisedBy">Name</label>
            <input
              type="text"
              id="authorisedBy"
              name="authorisedBy"
              value={formData?.authorisedBy ?? ""}
              onChange={handleFormData}
            />
          </div>
          <div className="formLine">
            <label htmlFor="number">Number</label>
            <input
              type="text"
              id="number"
              name="number"
              value={formData?.number ?? ""}
              onChange={handleFormData}
            />
          </div>

          <div className="formLine">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              id="email"
              name="email"
              value={formData?.email ?? ""}
              onChange={handleFormData}
            />
          </div>
          <div className="jobDetailsLine">
            <label htmlFor="jobDetails">Job Details</label>
            <textarea
              rows={4}
              id="jobDetails"
              name="jobDetails"
              value={formData?.jobDetails ?? ""}
              onChange={handleFormData}
            />
          </div>
        </div>

        <div>
          <div className="formLine">
            <label htmlFor="address">Address</label>
            <input
              type="text"
              id="address"
              name="address"
              value={formData?.address ?? ""}
              onChange={handleFormData}
            />
          </div>
          <div className="formLine">
            <label htmlFor="address2">Address Line 2</label>
            <input
              type="text"
              id="address2"
              name="address2"
              value={formData?.address2 ?? ""}
              onChange={handleFormData}
            />
          </div>

          <div>
            <div className="formLine">
              <label htmlFor="flat">Flat</label>
              <input
                type="text"
                id="flat"
                name="flat"
                value={formData?.flat ?? ""}
                onChange={handleFormData}
              />
            </div>
            <div className="formLine">
              <label htmlFor="postcode">Postcode</label>
              <input
                type="text"
                id="postcode"
                name="postcode"
                value={formData?.postcode ?? ""}
                onChange={handleFormData}
              />
            </div>
          </div>
        </div>
      </form>
      <button
        onClick={() => addAsJobsheet(formData)}
        title="Create Jobsheet"
        className="createJobsheetFromCall"
      >
        {/* <p>Create</p> */}
        <AddCircleIcon className="icon" style={{ fontSize: 32 }} />
      </button>
    </div>
  );
}

export default IncomingCallForm;
